module.exports = __webpack_public_path__ + "img/thumb-hyacintus-henry-djantoko.d2cbffc6.png";